
const baseMessage = require('@/system/locales/hsb/zh-cn.js');

module.exports = baseMessage;
